import { render, staticRenderFns } from "./AddTags.vue?vue&type=template&id=23146bce&"
import script from "./AddTags.vue?vue&type=script&lang=js&"
export * from "./AddTags.vue?vue&type=script&lang=js&"
import style0 from "./AddTags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VApp,VChip,VCombobox})
